import { Link } from "react-router-dom"

import variables from "@/_styles/variables.module.scss"
import { getAuthorityRegisterLogFileById } from "@/http/authorities"

import { IAuthorityRegisterLogs, IAuthorityRegisterRequest, LogStatusColors } from "@/types/IAuthorities"
import { ITableColumn } from "@/types/ui"

import { paths } from "@/router/paths"

import { downloadFile } from "@/utils/download"
import { dateTimeFormat, formatDate } from "@/utils/formatDate"


export const authorityRegisterLogsColumns: ITableColumn<IAuthorityRegisterLogs>[] = [
  {
    title: "Доверенность",
    key: "authorityNumber",
    dataIndex: ["authorityNumber"],
    render:  (_, { id, authorityNumber }) =>
      <Link to={paths.authoritiesById(id)}>
        {authorityNumber}
      </Link>,
    align: "center",
    width: 120,
    sorter: true,
    isVisible: true,
    order: 1
  },
  {
    title: "Дата (начало)",
    key: "startDateTime",
    dataIndex: ["startDateTime"],
    render: (_: any, { startDateTime }) => <>{startDateTime && <span>{formatDate(startDateTime, dateTimeFormat)}</span>}</>,
    align: "center",
    width: 140,
    sorter: true,
    isVisible: true,
    order: 2
  },
  {
    title: "Дата (конец)",
    key: "endDateTime",
    dataIndex: ["endDateTime"],
    render: (_: any, { endDateTime }) => <>{endDateTime && <span>{formatDate(endDateTime, dateTimeFormat)}</span>}</>,
    align: "center",
    width: 140,
    sorter: true,
    defaultSortOrder: "descend",
    isVisible: true,
    order: 3
  },
  {
    title: "Параметры запроса",
    key: "requestParams",
    dataIndex: ["requestParams"],
    render: (_: any, { requestParams }) => {
      const noneRender = <>-</>
      if (!requestParams) {
        return noneRender
      }
      const jsonRequest = requestParams ? JSON.parse(requestParams) as IAuthorityRegisterRequest : null

      if (!jsonRequest) {
        return noneRender
      }
      return <>
      <span>НомерДоверенности: {jsonRequest.Number}</span><br/>
      <span>ДатаДоверенности: {formatDate(jsonRequest.Date, dateTimeFormat)}</span><br/>
      <span>ФИОВодителя: {jsonRequest.DriverFullName}</span><br/>
      <span>ИНН: {jsonRequest.Inn}</span><br/>
      <span>КПП: {jsonRequest.Kpp}</span>
      </>
    },
    align: "left",
    width: 100,
    sorter: false,
    isVisible: true,
    order: 4
  },
  {
    title: "Тескт ошибки",
    key: "errorText",
    dataIndex: ["errorText"],
    align: "center",
    width: 100,
    sorter: false,
    isVisible: true,
    order: 5
  },
  {
    title: "Статус",
    key: "status",
    dataIndex: ["statusText"],
    align: "center",
    render: (_, { status, statusText }) => 
      <>
        <span style={{ fontWeight: 600, color: LogStatusColors[status] }}>
          {statusText}
        </span>
      </>,
    width: 120,
    sorter: true,
    isVisible: true,
    order: 6
  },
  {
    title: "Скачать файл ответа",
    key: "storageKey",
    dataIndex: ["storageKey"],
    align: "center",
    render:  (_, { id, storageKey }) =>
      <span
        style={{ padding: 19, color: variables.basecolorlight, borderColor: variables.basecolorlight }}
        onClick={async (e) => {downloadFile(await getAuthorityRegisterLogFileById(id))
          .then()
          e.preventDefault()
          e.stopPropagation()
        }}
      >
        {storageKey ? storageKey.split("/").pop() : ""}
      </span>,
    width: 120,
    sorter: true,
    isVisible: true,
    order: 7
  }
]